import { node } from "~/util/dom";
import { IStructuredItem } from "~/review/interfaces";
import { getEmo1Pos, getEmo1Neg } from "./emojis-list";
import { POS_SMILEY_VAL, NEG_SMILEY_VAL, UNSET_SMILEY_VAL } from "~/review/const";

function createEmoLine(isPositive: boolean, items: Array<IStructuredItem>, size: number): HTMLDivElement {
	const itemEl = node("div", { className: "review-emojis-preview-item" });
	const emoji = node("span", { className: "review-emojis-preview-emoji" });
	const msg = items.map(item => item.name).join(", ");
	const caption = node("span", { className: "review-emojis-preview-caption", textContent: msg });
	const emoSource = isPositive ? getEmo1Pos : getEmo1Neg;

	emoji.append(emoSource({
		active: true,
		hover: false,
		size,
	}).container);
	itemEl.append(
		emoji,
		caption,
	);

	return itemEl;
}

interface ICreateEmojisPreview {
	config: Array<IStructuredItem>;
	size?: number;
}

export function createEmojisPreview({
	config = [],
	size = 20,
}: ICreateEmojisPreview): {
	isHidden: boolean;
	container: HTMLDivElement;
} {
	const container = node("div", { className: "review-emojis-preview" });
	const positive = config.filter(item => item.rating === POS_SMILEY_VAL);
	const negative = config.filter(item => item.rating !== UNSET_SMILEY_VAL && item.rating >= NEG_SMILEY_VAL && item.rating < POS_SMILEY_VAL);
	const isHidden = !positive.length && !negative.length;

	if (positive.length) {
		container.append(
			createEmoLine(true, positive, size),
		);
	}

	if (negative.length) {
		container.append(
			createEmoLine(false, negative, size),
		);
	}

	if (isHidden) {
		container.style.display = "none";
	}

	return {
		isHidden,
		container,
	};
}
